import angular from "angular";
import accountService from './account.service';

let accountModule = angular.module('account.service', [])
.service('Account', accountService)

.name;

export default accountModule;



// WEBPACK FOOTER //
// ./client/app/services/accountService/account.js